import { useMemo } from 'react';

import type {
    ElementChipInteractionProps,
    InteractiveElementChipDescriptor,
    ElementChipDescriptor,
} from '../elementChipsTypes';

export type ElementChipCallbackSet = (chip: ElementChipDescriptor) => Partial<ElementChipInteractionProps>;

const DEFAULT_INTERACTION: ElementChipInteractionProps = {
    isSelected: false,
    isEditing: false,
    canModify: false,
    canActivate: false,
};

/**
 * Applies type-owned interaction callbacks to plain render descriptors.
 */
export const useElementChipCallbacks = ({
    chips,
    callbackSets,
}: {
    chips: ElementChipDescriptor[];
    callbackSets: ElementChipCallbackSet[];
}): InteractiveElementChipDescriptor[] =>
    useMemo(
        () =>
            chips.map((chip) => ({
                ...chip,
                interaction: callbackSets.reduce(
                    (interaction, callbackSet) => ({ ...interaction, ...callbackSet(chip) }),
                    DEFAULT_INTERACTION,
                ),
            })),
        [callbackSets, chips],
    );
